import { useEffect } from 'react';
import { useListContext, useUnselectAll } from 'react-admin';

const ResetSelection = () => {
    const { resource, selectedIds } = useListContext();
    const unselectAll = useUnselectAll(resource);

    useEffect(() => {
        if (!resource) return;

        // Find keys where RA stores selection for this resource
        const keys = Object.keys(localStorage).filter(
            k => k.includes(resource) && k.endsWith('.selectedIds')
        );

        console.log('Clearing selection keys:', keys);

        keys.forEach(k => localStorage.removeItem(k));

        if (selectedIds?.length) {
            console.log('Unselecting in-memory state for', resource);
            unselectAll();
        }
    }, [resource]);

    return null;
};

export default ResetSelection;
